export default function VideoListHolder(props) {

  return <div className="container">
          <div className="row">
              {props.children}
        </div>
  </div>
}
